// Main Library searches rank by relevance; favorites/recent endpoints filter
// within a saved list and retain the user's selected order.
export const LIBRARY_SORT_OPTIONS = [
  { key: 'popular', label: 'Relevant' },
  { key: 'usage', label: 'Most Used' },
  { key: 'updated', label: 'Recently Updated' },
];
const DEFAULT_SORT = { key: 'popular', direction: 'desc' };
export function normalizeLibrarySort(sort) {
  return LIBRARY_SORT_OPTIONS.some((option) => option.key === sort?.key) ? sort : DEFAULT_SORT;
}

export function libraryRequestSort(sort, search, scope) {
  return search?.trim() && (scope === 0 || scope === 1)
    ? { key: 'best', direction: 'desc' }
    : sort;
}
